import { FC, useEffect, useState } from "react";
import { Loader, Modal, Table } from "venice-ui";
import { apiCall } from "../../untils/apiCall";
import { invoiceListHeader } from "../../definitions/ListDefinition";
import { IInvoicesType, getInvoiceUrl } from "../../helpers/settingsHelper";
import { t } from "../../helpers/userHelper";
import { dictionary } from "../../untils/dictionary";
import { useStoreState } from "../../store";

interface IInvoicesModalProps {
  show: boolean;
  onClose: () => void;
  fakturowniaCustomerID:string
}
interface IInvoicesPropsType {
  loading: boolean;
  invoices: IInvoicesType[];
}

export const InvoicesModal: FC<IInvoicesModalProps> = ({ show, onClose, fakturowniaCustomerID }) => {
  const { uid } = useStoreState((state) => state.user.userDetails);

  const [pageProps, updatePageProps] = useState<IInvoicesPropsType>({
    loading: true,
    invoices: [],
  });

  const getInvoices = async () => {
    const options = {
      userID: uid,
      fakturowniaCustomerId: fakturowniaCustomerID,
    };
    await apiCall("payments/getInvoices", options, (response: any) => {
      updatePageProps({
        loading: false,
        invoices: response.invoices,
      });
    });
  };

  useEffect(() => {
    if (show) {
      getInvoices();
    }
  }, [show]);

  const downloadInvoice = (id: string) => {
    const url = getInvoiceUrl(pageProps.invoices, id);
    const download = window.open(url, "_blank");
    if (download) {
      download.focus();
    }
  };

  return (
    <>
      {show && (
        <Modal
          title={t(dictionary.invoicesList)}
          labelClose={t(dictionary.close)}
          handleClose={onClose}
          size="medium"
          isOpen={show}
          exitOnEsc={true}
        >
          {pageProps.loading ? (
            <Loader />
          ) : (
            <Table
              headers={invoiceListHeader}
              elements={pageProps.invoices}
              sortable={false}
              selectable={false}
              filtrable={false}
              onRowClick={downloadInvoice}
            />
          )}
        </Modal>
      )}
    </>
  );
};
